import { toastr } from 'react-redux-toastr';

import httpStatusCodes from '../constants/http-status-codes';
import config from '../config';
import { checkInternetConnection } from './internet-connection-checker';

export default function handleError(error, errorMessage) {
  checkInternetConnection().then(
    () => {
      const { response } = error;

      if (response && response.status === httpStatusCodes.Unauthorized) {
        toastr.warning('Auth token is invalid or expired. Please re-sign in.', {
          timeOut: 0
        });
      } else {
        if (response) {
          toastr.error(errorMessage || error.message, { timeOut: 0 });
        }

        if (config.debug) {
          const logError = console.error || console.log;
          logError(error);
        }
      }
    },
    () =>
      toastr.error(
        'Network connection is absent. Please check it and try again.',
        { timeOut: 0 }
      )
  );
}



// WEBPACK FOOTER //
// ./src/tools/error-helper.js